import { render, staticRenderFns } from "./CustomerDetailDialog.vue?vue&type=template&id=498921b0"
import script from "./CustomerDetailDialog.vue?vue&type=script&lang=js"
export * from "./CustomerDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports